module.exports = __webpack_public_path__ + "img/CIRCLES.8a478f71.png";